export function IconFunction() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 3.125C16.25 3.29076 16.1842 3.44973 16.0669 3.56694C15.9497 3.68415 15.7908 3.75 15.625 3.75H13.3367C12.8975 3.74988 12.4721 3.90397 12.1349 4.18539C11.7977 4.4668 11.5699 4.85768 11.4914 5.28984L10.7492 9.375H14.375C14.5408 9.375 14.6997 9.44085 14.8169 9.55806C14.9342 9.67527 15 9.83424 15 10C15 10.1658 14.9342 10.3247 14.8169 10.4419C14.6997 10.5592 14.5408 10.625 14.375 10.625H10.5219L9.74062 14.9344C9.60955 15.6548 9.22964 16.3063 8.66721 16.7752C8.10478 17.2442 7.39554 17.5007 6.66328 17.5H4.375C4.20924 17.5 4.05027 17.4342 3.93306 17.3169C3.81585 17.1997 3.75 17.0408 3.75 16.875C3.75 16.7092 3.81585 16.5503 3.93306 16.4331C4.05027 16.3158 4.20924 16.25 4.375 16.25H6.66328C7.10252 16.2501 7.52785 16.096 7.8651 15.8146C8.20234 15.5332 8.43008 15.1423 8.50859 14.7102L9.25078 10.625H5.625C5.45924 10.625 5.30027 10.5592 5.18306 10.4419C5.06585 10.3247 5 10.1658 5 10C5 9.83424 5.06585 9.67527 5.18306 9.55806C5.30027 9.44085 5.45924 9.375 5.625 9.375H9.47813L10.2594 5.06563C10.3905 4.34519 10.7704 3.69367 11.3328 3.22476C11.8952 2.75585 12.6045 2.49934 13.3367 2.5H15.625C15.7908 2.5 15.9497 2.56585 16.0669 2.68306C16.1842 2.80027 16.25 2.95924 16.25 3.125Z"
        fill="currentColor"
      />
    </svg>
  )
}
